import {
  Box,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import { Dispatch, SetStateAction, useState } from "react";
import { CustomEvent } from "schemas/functions";

interface IProps {
  campaignTitle: string;
  setCampaignTitle: Dispatch<SetStateAction<string>>;
  onComplete?: (newTitle: string) => void;
}

export default function EditTitle({
  campaignTitle,
  setCampaignTitle,
  onComplete = undefined,
}: IProps) {
  const [isEditing, setIsEditing] = useState<boolean>(false);

  return (
    <DialogTitle>
      <Grid container alignItems="center" justifyContent="center">
        {isEditing ? (
          <TextField
            variant="standard"
            value={campaignTitle}
            onChange={(e: CustomEvent) => {
              const { value } = e.target;
              setCampaignTitle(value);
            }}
            InputProps={{
              sx: (theme) => ({
                fontSize: theme.typography.h4.fontSize,
                fontWeight: theme.typography.h4.fontWeight,
                fontFamily: theme.typography.h4.fontFamily,
                lineHeight: theme.typography.h4.lineHeight,
                letterSpacing: theme.typography.h4.letterSpacing,
              }),
            }}
            sx={{
              p: 0,
              m: 0,
            }}
            onBlur={() => {
              if (campaignTitle) {
                setIsEditing(false);
                if (onComplete) {
                  onComplete(campaignTitle);
                }
              }
            }}
            onKeyDown={(e: CustomEvent) => {
              if (e.key === "Enter") {
                if (campaignTitle) {
                  setIsEditing(false);
                  if (onComplete) {
                    onComplete(campaignTitle);
                  }
                }
              }
            }}
          />
        ) : (
          <Typography component="span" variant="h4">
            {campaignTitle}
          </Typography>
        )}

        <IconButton
          color="secondary"
          size="small"
          onClick={() => {
            if (!campaignTitle && isEditing) {
              return;
            }
            if (isEditing) {
              if (onComplete) {
                onComplete(campaignTitle);
              }
            }
            setIsEditing(!isEditing);
          }}
          sx={{ ml: 2 }}
        >
          <Box
            component="i"
            className={isEditing ? "fa-solid fa-check" : "fa-solid fa-pen"}
          />
        </IconButton>
      </Grid>
      {!campaignTitle && (
        <Grid container justifyContent="center">
          <Typography variant="caption" color="error.main">
            A title is required
          </Typography>
        </Grid>
      )}
    </DialogTitle>
  );
}
